const { useReducer, useEffect, createContext, useState } = require("react");

import store from "store";
import { appReducer } from "./reducers";
export const AppDataContext = createContext();

export const AppProvider = ({ children }) => {
  const savedSData = store.get("app_data") || {
    categoryData: {},
    menuTreeData: [],
    megaMenuTreeData: [],
    regionId: null,
    cacheTime: 0,
  };

  const [hydrated, setHydrated] = useState(false);

  const [appData, dispatch] = useReducer(appReducer, { ...savedSData });

  useEffect(() => {
    if (Object.keys(appData).length > 0) {
      store.set("app_data", appData);
    }
  }, [appData]);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return (
    <AppDataContext.Provider value={{ appData, dispatch, hydrated }}>
      {children}
    </AppDataContext.Provider>
  );
};
